import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/axios';

function AccessRequestList() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [filters, setFilters] = useState({
    text: '',
    status: '',
    startDate: '',
    endDate: '',
    urgent: '',
    page: 0,
  });

  useEffect(() => {
    loadRequests();
  }, [filters]);

  const loadRequests = async () => {
    setLoading(true);
    setError('');
    try {
      const filterParams = { ...filters };
      if (filterParams.urgent === '') delete filterParams.urgent;
      if (filterParams.status === '') delete filterParams.status;
      if (filterParams.text === '') delete filterParams.text;
      if (filterParams.startDate === '') delete filterParams.startDate;
      if (filterParams.endDate === '') delete filterParams.endDate;
      
      // Use central axios instance; pass filters as params. Axios interceptor
      // will only attach Authorization when getAuthToken() returns a value.
      const response = await api.get('/access-requests', { params: filterParams });
      const data = response.data;
      console.log('Resposta da API:', data);
      
      // O backend retorna um Page<AccessRequestResponseDTO>
      // AccessRequestResponseDTO agora retorna os dados diretamente (sem campo "request")
      let requestsArray = [];
      
      if (Array.isArray(data)) {
        requestsArray = data;
      } else if (data && data.content) {
        // Se for objeto Page do Spring, extrair content
        requestsArray = data.content;
      } else if (data) {
        // Se for um único objeto
        requestsArray = [data];
      }
      
      console.log('Solicitações processadas:', requestsArray);
      setRequests(requestsArray);
    } catch (err) {
      console.error('Erro ao carregar solicitações:', err.message);
      console.error('Request URL:', err.config?.url);
      console.error('Status:', err.response?.status);
      console.error('Dados:', err.response?.data);
      setError(
        err.response?.data?.message ||
        err.response?.data ||
        'Erro ao carregar solicitações'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value, page: 0 });
  };

  const getStatusBadgeClass = (status) => {
    const statusMap = {
      PENDING: 'status-pending',
      APPROVED: 'status-approved',
      REJECTED: 'status-rejected',
      CANCELED: 'status-canceled',
      EXPIRED: 'status-expired',
    };
    return `badge status-badge ${statusMap[status] || 'bg-secondary'}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Minhas Solicitações</h2>
        <Link to="/requests/new" className="btn btn-primary">
          Nova Solicitação
        </Link>
      </div>

      <div className="card shadow mb-4">
        <div className="card-header bg-light">
          <h5 className="mb-0">Filtros</h5>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <label htmlFor="filterText" className="form-label">
                Buscar (texto)
              </label>
              <input
                type="text"
                className="form-control"
                id="filterText"
                value={filters.text}
                onChange={(e) => handleFilterChange('text', e.target.value)}
                placeholder="Buscar por texto..."
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="filterStatus" className="form-label">
                Status
              </label>
              <select
                className="form-select"
                id="filterStatus"
                value={filters.status}
                onChange={(e) => handleFilterChange('status', e.target.value)}
              >
                <option value="">Todos</option>
                <option value="PENDING">Pendente</option>
                <option value="APPROVED">Aprovado</option>
                <option value="REJECTED">Rejeitado</option>
                <option value="CANCELED">Cancelado</option>
                <option value="EXPIRED">Expirado</option>
              </select>
            </div>
            <div className="col-md-2">
              <label htmlFor="filterUrgent" className="form-label">
                Urgente
              </label>
              <select
                className="form-select"
                id="filterUrgent"
                value={filters.urgent}
                onChange={(e) => handleFilterChange('urgent', e.target.value)}
              >
                <option value="">Todos</option>
                <option value="true">Sim</option>
                <option value="false">Não</option>
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor="filterStartDate" className="form-label">
                Data Início
              </label>
              <input
                type="date"
                className="form-control"
                id="filterStartDate"
                value={filters.startDate}
                onChange={(e) => handleFilterChange('startDate', e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="filterEndDate" className="form-label">
                Data Fim
              </label>
              <input
                type="date"
                className="form-control"
                id="filterEndDate"
                value={filters.endDate}
                onChange={(e) => handleFilterChange('endDate', e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {loading ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Carregando...</span>
          </div>
        </div>
      ) : requests.length === 0 ? (
        <div className="alert alert-info" role="alert">
          Nenhuma solicitação encontrada.
        </div>
      ) : (
        <div className="card shadow">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Módulos</th>
                    <th>Status</th>
                    <th>Urgente</th>
                    <th>Data Criação</th>
                    <th>Data Expiração</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.map((request) => (
                    <tr key={request.id}>
                      <td>{request.id}</td>
                      <td>
                        {request.modules?.map((m) => m.name).join(', ') || '-'}
                      </td>
                      <td>
                        <span className={getStatusBadgeClass(request.status)}>
                          {request.status}
                        </span>
                      </td>
                      <td>
                        {request.urgent ? (
                          <span className="badge bg-warning text-dark">Sim</span>
                        ) : (
                          <span className="badge bg-secondary">Não</span>
                        )}
                      </td>
                      <td>{formatDate(request.requestDate)}</td>
                      <td>{formatDate(request.expirationDate)}</td>
                      <td>
                        <Link
                          to={`/requests/${request.id}`}
                          className="btn btn-sm btn-outline-primary"
                        >
                          Ver Detalhes
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AccessRequestList;
